module.exports = __webpack_public_path__ + "static/media/mobile_join_artWork_top.b64796e7.svg";